module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/custom_theme-cccfe35de0d8a5c8bdcc7b8b8287f315.png";